module.exports = __webpack_public_path__ + "static/media/wicket.bb44e4ba.jpg";